import React from 'react';

import wrapMain from '../../wrap-main';

import Table from '../../../shared/new-table/main';
import table from './table-initial-data';

import { enum as campaigns } from '../../../../../../../enums/banner-campaigns';

function CampaignList() {
	return (
		<Table table={table} rows={campaigns} />
	);
}

export default wrapMain(CampaignList);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/campaign/list/main.js